import { useEffect, useState, useCallback } from 'react';
import { useGetDataSource, useLazyGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
export const useGetDataProperty = ({
  prefix,
  property,
  options = {}
}) => {
  const {
    data: queryData,
    loading: queryLoading,
    error
  } = useGetDataSource({
    prefix,
    options
  });
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (queryLoading) {
      return;
    }
    if (error) {
      setLoading(false);
      return;
    }
    if (queryData) {
      const dataSourceProperty = queryData.dataSourceProperties[property];
      setLoading(false);
      setData({
        dataSourceDefinition: queryData.dataSourceDefinition,
        dataSourceProperty
      });
    }
  }, [queryData, queryLoading, error, property]);
  return {
    data,
    loading,
    error
  };
};
export const useLazyGetDataProperty = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const {
    getDataSourceWithAPromise,
    error
  } = useLazyGetDataSource();
  const getDataProperty = propertyReq => {
    const {
      prefix: queryPrefix,
      property: queryProperty,
      options = {}
    } = propertyReq;
    getDataSourceWithAPromise({
      prefix: queryPrefix,
      options
    }).then(queryRes => {
      const dataSourceDefinition = queryRes.dataSourceDefinition;
      const dataSourceProperty = queryRes.dataSourceProperties[queryProperty];
      setData({
        dataSourceDefinition,
        dataSourceProperty
      });
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };
  const getDataPropertyByToken = token => {
    const splitToken = token.split('.');
    const propertyReq = splitToken.pop() || '';
    const prefixReq = splitToken.join('.') || '';
    getDataProperty({
      prefix: prefixReq,
      property: propertyReq
    });
  };

  // Specific use case methods that return a promise //
  const getDataPropertyWithAPromise = useCallback(propertyReq => {
    const {
      prefix: queryPrefix,
      property: queryProperty,
      options = {}
    } = propertyReq;
    return getDataSourceWithAPromise({
      prefix: queryPrefix,
      options
    }).then(queryRes => {
      const dataSourceDefinition = queryRes.dataSourceDefinition;
      const dataSourceProperty = queryRes.dataSourceProperties[queryProperty];
      return {
        dataSourceDefinition,
        dataSourceProperty
      };
    });
  }, [getDataSourceWithAPromise]);
  const getDataPropertyTokenWithAPromise = useCallback(token => {
    const splitToken = token.split('.');
    const propertyReq = splitToken.pop() || '';
    const prefixReq = splitToken.join('.') || '';
    return getDataPropertyWithAPromise({
      prefix: prefixReq,
      property: propertyReq
    });
  }, [getDataPropertyWithAPromise]);
  return {
    getDataProperty,
    getDataPropertyByToken,
    getDataPropertyWithAPromise,
    getDataPropertyTokenWithAPromise,
    data,
    loading,
    error
  };
};